export default __webpack_public_path__ + "static/media/Bolo-De-Caramel.71c2747c.jpg";